<template>
  <div>
    <v-tabs height="60px" show-arrows v-model="currentTab" background-color="#434343" color="#d59e1d">
      <v-tab href="#tab-ongoing-trips">Ongoing Trips</v-tab>
      <v-tab href="#tab-ended-trips">Completed Trips</v-tab>
      <v-tab href="#tab-error-trips">Error Trips</v-tab>
    </v-tabs>

    <v-tabs-items v-model="currentTab">
      <v-tab-item id="tab-ongoing-trips" class="tab-outer" transition="fade-transition" reverse-transition="fade-transition">
        <TripHistory tripStatus="ongoing" v-if="currentTab === 'tab-ongoing-trips'"></TripHistory>
      </v-tab-item>
      <v-tab-item id="tab-ended-trips" class="tab-outer" transition="fade-transition" reverse-transition="fade-transition">
        <TripHistory tripStatus="ended" v-if="currentTab === 'tab-ended-trips'"></TripHistory>
      </v-tab-item>
      <v-tab-item id="tab-error-trips" class="tab-outer" transition="fade-transition" reverse-transition="fade-transition">
        <ErrorTripList v-if="currentTab === 'tab-error-trips'"></ErrorTripList>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import TripHistory from "./TripHistory.vue";
import ErrorTripList from "./ErrorTripList.vue";

export default {
  name: "IndigoTrips",
  components: { TripHistory, ErrorTripList },
  props: {
    defaultTab: {
      type: String,
      default: "tab-ongoing-trips",
    },
  },
  data() {
    return {
      currentTab: this.defaultTab,
    };
  },
  watch: {
    defaultTab(newVal) {
      this.currentTab = newVal;
    },
  },
};
</script>

<style lang="scss" scoped>
.trip-filter-blk {
  padding: 20px;
  background-color: white;
  width: 100%;
  border-radius: 5px;
  display: flex;
  align-items: center;
}
</style>
